export default {
  categoryInfo: {
    mainTitle: 'Dask Deprem Sigortası',
    description: {
      title: 'DASK Ne Demek?',
      content: ['DASK; Doğal Afet Sigortaları Kurumu’nun kısaltmasıdır.']
    },
    subContent: {
      title: 'DASK (Zorunlu Deprem Sigortası) Nedir?',
      content: [
        {
          paragraph:
            'Yaşadığımız meskenlerde deprem sonucu oluşabilecek hasarlara karşı bizi güvence altına alan sigorta türüdür.',
          subList: null
        },
        {
          paragraph:
            '17 Ağustos 1999 Marmara depremi sonucunda gündeme zorunlu deprem sigortası depremin binalarda yol açtığı zarar ve hasarları karşılamaktadır.',
          subList: null
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'DASK Adres Kodu Nedir?',
      content: [
        {
          paragraph:
            'Adres kodu; DASK poliçesi kesilmesi için meskene ait adresin tanımlı olduğu koddur.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Bina Kodu Ne Demek?',
      content: [
        {
          paragraph:
            'Poliçeye konu binanın UAVT (Ulusal Adres Veri Tabanı) ‘deki tanımlı adresine ait bir çeşit kimlik numarasıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK UAVT Ne Demek?',
      content: [
        {
          paragraph:
            'DASK poliçesi kesilebilmesi için gereken binanın adresinin bulunduğu 10 haneli numaraya UAVT kodu denir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Sigorta Bedeli Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'DASK, her takvim yılında yapı maliyetlerindeki artışın tespiti ile belirlenen azami bir tutara kadar teminat sunar.',
            'Azami Teminat Tutarı tespitinde binaların arsa bedeli hariç yeniden inşa bedeli dikkate alınır.',
            'Sigorta yaptıranların teminat tutarları (sigorta bedeli), bu azami teminat tutarını geçmemesi kaydıyla, meskenlerinin metre kare büyüklüğüne ve yapı tarzına/tipine göre belirlenir',
            'Sadece yurt dışına ait alacakları bulunanlar.',
            'Eğer meskenin değeri DASK tarafından verilen teminat tutarını aşıyorsa, sigortalı, aşan kısım için ulusal sigorta şirketlerinden isteğe bağlı olarak konut sigortası yaptırarak aradaki farkı teminat altına alabilirler'
          ]
        }
      ]
    },
    {
      title: 'DASK Kanunu (Doğal Afet Sigortalar Kurumu) Nedir?',
      content: [
        {
          paragraph:
            'Doğal Afet Sigortalar Kurumu, 17 Ağustos 1999 depreminden sonra 2000 yılında kurulan Türkiye’de Zorunlu Deprem Sigortası edindirilmesini, tanıtılmasını, uygulama ve yönetimi faaliyetlerinden sorumlu tüzel kimlikli bir kamu kuruluşudur.',
          subList: null
        },
        {
          paragraph:
            '“<strong>6305 sayılı Afet Sigortaları Kanunu</strong>” Bakanlar Kurulu tarafından 25.11.1999 tarihinde kararlaştırılmıştır.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Deprem Sigortası ZDS Teminatları Neler?',
      content: [
        {
          paragraph:
            'DASK, Zorunlu Deprem Sigortası ile depremin ve deprem sonucu meydana gelen zararlara karşı güvence sağlar. Depremin neden olabileceği yangın, infilak, tsunami ve yer kaymasının doğrudan oluşturacağı maddi zararları poliçede belirtilmiş limitlere kadar karşılar.',
          subList: null
        },
        {
          paragraph:
            '“Bina tamamen ya da kısmi olarak zarar görmüş olsa da teminat altındadır.',
          subList: null
        },
        {
          paragraph:
            'Aşağıda yer alan bina bölümleri, bir arada ya da ayrı ayrı teminat ile poliçeye eklenebilir.',
          subList: [
            'Ana duvarlar',
            'Asansörler',
            'Bacalar',
            'Bağımsız bölümleri ayıran ortak duvarlar',
            'Bahçe duvarları',
            'Çatılar',
            'İstinat duvarları',
            'Koridorlar',
            'Merdivenler',
            'Sahanlıklar',
            'Tavan ve tabanlar',
            'Temeller'
          ]
        },
        {
          paragraph:
            '“Yapının yukarıdakilerle benzer nitelikteki tamamlayıcı bölümleri de teminat kapsamındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Zorunlu Deprem Sigortası Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası genel anlamıyla, belediye idari sınırları içinde kalan meskenler için geliştirilmiş bir güvence sistemidir.',
          subList: null
        },
        {
          paragraph:
            '6305 sayılı Afet Sigortaları kanunu gereğince, güvence altına alınabilecek binalar:',
          subList: [
            'Tapuya kayıtlı olan ve özel mülkiyete tâbi olan taşınmazlar üzerinde mesken olarak inşa edilen binalar,',
            '634 sayılı Kat Mülkiyeti Kanunu kapsamında yer alan bağımsız bölümler,',
            'Bu binaların içinde yer alan ve ticarethane, büro ve benzeri amaçlarla kullanılan bağımsız bölümler,',
            'Doğal afetler nedeniyle devlet tarafından yaptırılan veya verilen kredi ile yapılan meskenler.'
          ]
        },
        {
          paragraph:
            'Ayrıca Zorunlu Deprem Sigortası yukarıdaki koşullara sağlayan;',
          subList: [
            'Kat irtifakı tesis edilmiş binalar,',
            'Tapuda henüz cins tashihi yapılmamış ve tapu kütüğünde vasfı "arsa vs." olarak görünen binalar,',
            'Tapu tahsisi henüz yapılmamış kooperatif evleri için geçerlidir.'
          ]
        }
      ]
    },
    {
      title: 'DASK Yaptırmak Neden Önemlidir?',
      content: [
        {
          paragraph:
            'Türkiye jeopolitik konumundan dolayı dünyada aktif deprem kuşaklarından birinin üzerinde yer almaktadır. Nüfus yoğunluğunun çok büyük bir bölümü bu deprem bölgelerinde bulunur. Ayrıca bu nüfusun korunmasız binalarda yaşıyor olduğunu düşündüğümüzde deprem sigortasının önemi de kendiliğinden ortaya çıkmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Ülkemizde deprem ve deprem sonucu meydana gelebilecek yer kayması, göçükler, sel, yangın, tsunami gibi risklere karşı güvence sağlayan deprem sigortası, deprem bittikten sonra binada oluşan maddi kayıpları teminat limitlerinde karşılayarak normal yaşama dönülmesini amaçlar.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Sigortasını Kim Yaptırır?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası, meskende oturan ev sahibi ya da kiracı tarafından yaptırılabilir. Sigorta ettiren kim olursa olsun poliçede sigortalı, ev sahibidir.',
          subList: null
        },
        {
          paragraph:
            'Kiracılar yalnızca sigorta ettiren olarak zorunlu deprem sigortası yaptırabilir. Bu durumda sigorta ettiren sıfatıyla poliçe priminin ödenmesi sorumluluğu kiracıya aittir. Ancak her durumda poliçe ev sahibi adına düzenleneceğinden; sigorta ettiren kiracı da olsa prim bedelini ev sahibinden alabilir ya da kiradan kesebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Deprem Sigortasını İş Yerleri De Yaptırabilir Mi?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası Genel Şartları A-2 Sigorta Kapsamı Dışında Kalan Binalar maddesi gereği; Tamamı ticarî veya sınaî amaçla kullanılan binalar, kapsam dışındadır. Ancak, mesken olarak inşa edilmiş binaların (apartmanların) içinde yer alan ve ticarethane, dükkân, büro ve benzeri amaçlarla kullanılan bağımsız bölümler için Zorunlu Deprem Sigortası yaptırılması gereklidir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK (Zorunlu Deprem Sigortası) Genel Şartları Nelerdir?',
      content: [
        {
          paragraph: '6305 sayılı Afet Sigortaları Kanunu gereğince;',
          subList: [
            '634 sayılı Kat Mülkiyeti Kanunu kapsamındaki bağımsız bölümler,',
            'Tapuya kayıtlı ve özel mülkiyete tabi taşınmazlar üzerinde mesken olarak inşa edilmiş binalar,',
            'Bu binalar içinde yer alan ve ticarethane, büro ve benzeri amaçlarla kullanılan bağımsız bölümler ile doğal afetler nedeniyle devlet tarafından yaptırılan veya verilen kredi ile yapılan meskenler Zorunlu Deprem Sigortasına tabidir.'
          ]
        },
        {
          paragraph:
            'DASK genel şartları kapsamında işlenen konular aşağıdaki gibidir.',
          subList: [
            'Sigortanın Kapsamı',
            'Sigorta Kapsamı Dışında Kalan Binalar',
            'Teminat Dışında Kalan Haller',
            'Sigorta Bedelinin Tespiti',
            'Aşkın Sigorta',
            'Muafiyet',
            'Sigortanın Başlangıcı Ve Sonu',
            'Hasar Ve Tazminat',
            'Rizikonun Gerçekleşmesi Halinde, Sigorta Ettirenin ya da Sigortalının Yükümlülükleri',
            'Hasarın Tespiti',
            'Tazminatın Hesabı',
            'Tazminatın Ödenmesi',
            'Hasar Ve Tazminatın Sonuçları',
            'Çeşitli Hükümler',
            'Sigorta Ücretinin Ödenmesi, Doğal Afet Sigortaları Kurumunun Sorumluluğunun Başlaması ve Sona Ermesi',
            'Sigorta Ettirenin Beyan Yükümlülüğü Fesih ve İptaller',
            'Birden Çok Sigorta',
            'Menfaat Sahibinin Değişmesi',
            'Tebliğ ve İhbarlar',
            'Tahkim ve Yetkili Mahkeme',
            'Zaman Aşımı',
            'Yürürlük konuları yer alır.'
          ]
        },
        {
          paragraph: '*** Genel şartlar tüm sigorta şirketlerinde aynıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Yaptırma Mecburi Mi?',
      content: [
        {
          paragraph: 'Zorunlu deprem sigortası yaptırmak mecburidir.',
          subList: null
        },
        {
          paragraph:
            'Nasıl ki araçlarımıza trafik sigortası yaptırıyoruz, meskenler içinde Zorunlu Deprem Sigortası yaptırmak mecburidir. Ayrıca kredi ile alınan binalarda kredinin onaylanması için DASK poliçesi yaptırmak zorunludur.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK (Zorunlu Deprem Sigortası) Zorunlu Mu, Cezası Var Mı?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası yaptırmak kanunen mecburi olmasına karşı herhangi bir cezası bulunmamaktadır. Ancak sigortasız binanın depremde hasar görmesi halinde ödeme yapılmayacağı da bilinmelidir. Bunun dışında elektrik, su, doğalgaz aboneliği için DASK poliçenizi yaptırmış olmanız gerekmektedir.            ',
          subList: null
        }
      ]
    },
    {
      title:
        'ZDS’nin (Zorunlu Deprem Sigortası) Geçerlilik Süresi Ne Kadardır?',
      content: [
        {
          paragraph: 'Zorunlu Deprem Sigortası nın süresi bir (1) yıldır.',
          subList: null
        },
        {
          paragraph:
            'Sigortanın her yıl poliçe süresi sona ermeden yenilenmesi gereklidir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Olmadan Elektrik Aboneliği Açılır Mı?',
      content: [
        {
          paragraph:
            'DASK olmadan elektrik aboneliği alınamaz. Abone olmak için Zorunlu Deprem Sigortasının yapılması şartı mevcuttur.',
          subList: null
        }
      ]
    },
    {
      title: 'Elektrik Aboneliği İçin DASK Gerekli Mi?',
      content: [
        {
          paragraph: 'Evet, Elektrik Aboneliği İçin DASK gereklidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Doğalgaz Aboneliği İçin DASK Gerekli Mi?',
      content: [
        {
          paragraph: 'Evet, Doğalgaz Aboneliği İçin DASK gereklidir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Neyi Kapsar, DASK (Zorunlu Deprem Sigortası) Neyi Karşılar?',
      content: [
        {
          paragraph:
            'DASK, Zorunlu Deprem Sigortası ile depremin ve deprem sonucu meydana gelen yangın, infilak, tsunami ve yer kaymasının doğrudan neden olacağı maddi zararları poliçede belirtilmiş limite kadarki bedelleri nakit olarak karşılar.',
          subList: null
        }
      ]
    },
    {
      title: 'Hangi Binalar Zorunlu Deprem Sigortası Kapsamındadır?',
      content: [
        {
          paragraph: null,
          subList: [
            'Tapuya kayıtlı ve özel mülkiyete tâbi taşınmazlar üzerinde mesken olarak inşa edilmiş binalar',
            '634 sayılı Kat Mülkiyeti Kanunu kapsamındaki bağımsız bölümler',
            'Bu binaların içinde yer alan ve ticarethane, büro ve benzeri amaçlarla kullanılan bağımsız bölümler',
            'Doğal afetler nedeniyle devlet tarafından yaptırılan veya verilen kredi ile yapılan meskenler'
          ]
        },
        {
          paragraph:
            'Zorunlu Deprem Sigortası ayrıca yukarıdaki koşullara uyan;',
          subList: [
            'Kat irtifakı tesis edilmiş binalar',
            'Tapuda henüz cins tashihi yapılmamış ve tapu kütüğünde vasfı "arsa vs." olarak görünen binalar',
            'Tapu tahsisi henüz yapılmamış kooperatif evleri için geçerlidir.'
          ]
        }
      ]
    },
    {
      title: 'Hangi Binalar Zorunlu Deprem Sigortası Kapsamında Değildir?',
      content: [
        {
          paragraph: null,
          subList: [
            'İnşaatı henüz tamamlanmamış olan bina ve binalar,',
            'Kamu kurum ve kuruluşlarına ait olan binalar,',
            'Köy yerleşim alanlarında yapılmış binalar,',
            'Mesken olarak kullanıma uygun olmayan, bakımsız, harap veya metruk binalar,',
            'Tamamı ticari ve sınai amaçlar için kullanılan binalar (İş Hanı - İş Merkezi - İdari Hizmet - Eğitim Merkezi vs.)',
            'Tapuya kayıtlı bulunmayan ve özel mülkiyete tâbi olmayan arazi ve arsaların (hazine arazileri vb.) üzerine inşa edilmiş binalar sigorta kapsamında değildir.'
          ]
        }
      ]
    },
    {
      title: 'DASK Yaptırmazsam Ne Olur?',
      content: [
        {
          paragraph:
            'DASK yaptırılmaz ise deprem sonucu binada oluşan hasarlar karşılanamaz. Oluşacak riskleri güvence altına alarak deprem sonucunda mağdur olmamak için DASK poliçenizi yaptırmanız önemlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Depremde Ev Yıkılırsa Ne Olur?',
      content: [
        {
          paragraph:
            'Depremden sonra evinizin olmayacağını düşünmek zor zamanların başlangıcı demektir. Deprem sonucunda evinizin yıkılırsa, DASK poliçeniz varsa, meydana gelen hasarlar karşılanır.',
          subList: null
        },
        {
          paragraph:
            'Deprem sigortası genellikle yapıya verilen hasarları öder ve masrafları güvence altına alır.',
          subList: null
        }
      ]
    },
    {
      title: 'Tapu Olmadan Zorunlu Deprem Sigortası Yapılıyor Mu?',
      content: [
        {
          paragraph: 'Tapu olmadan da ZDS kesilebilir.',
          subList: null
        },
        {
          paragraph:
            'Binanın adresi (uavt), yapı tarzı, yüz ölçümü, yapı yılı bilgileri ile poliçe kesilebilmektedir',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Deprem Sigortasında Eşyalar Teminat Kapsamında Mı?',
      content: [
        {
          paragraph:
            'Eşyalar teminat kapsamı dışındadır. Sadece bina yapı elemanları teminat kapsamındadır.',
          subList: null
        },
        {
          paragraph:
            'Eşyalarını güvence altına almak isteyen sigortalılar konut sigortası yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Sigortasında Sigorta Ettiren ile Sigortalının Farkı Nedir?',
      content: [
        {
          paragraph:
            'DASK Sigortasında sigorta ettiren; poliçeyi kestirerek prim ödemesini yapacak olan tarafı ifade eder.',
          subList: null
        },
        {
          paragraph:
            'Sigortalı ise poliçenin sahibi olup, tazminat ödemesinin yapılacağı tarafı ifade etmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Yenileme Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'DASK yenilemesi için <strong><em>alokasko.com</em></strong> sitesini ziyaret edebilirsiniz ya da 0216 371 67 77 numaralı telefonu arayarak en uygun poliçeyi alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Yenileme İndirimi Nedir?',
      content: [
        {
          paragraph:
            'DASK yenileme indirim oranları yenileme tekrar sayısına göre değişiklik gösterir.',
          subList: null
        },
        {
          paragraph:
            'Poliçenin 1. 2. ve 3. yenilemesinde %10 indirim uygulanır.',
          subList: null
        },
        {
          paragraph:
            'İlk üç yenilemeden sonraki işlemlerde ise indirim oranı %20 oranında sabitlenir.',
          subList: null
        },
        {
          paragraph:
            'Yenileme işlemlerinizi zamanında tamamlarsanız, zorunlu deprem sigortası poliçenizi her seferinde indirimli yaptırabilirsiniz. İndirim hakkınızın kaybolmaması için poliçe bitim tarihinden <strong><em>30 gün içinde</em></strong> yenileme yapılması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Alokasko.com uzmanlarını arayarak DASK poliçenizi hemen yaptırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Ortak Kullanım Alanları İçin Zorunlu Deprem Sigortası Poliçesi Düzenleniyor Mu?',
      content: [
        {
          paragraph:
            'Ortak kullanım alanları binaya ait bir bölüm olduğundan ZDS poliçe kapsamında güvence altına alınmıştır.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK (Zorunlu Deprem Sigortası) Nerede Yaptırabilirim?',
      content: [
        {
          paragraph:
            'Deprem sigortası yaptırmak oldukça kolaydır. Online deprem sigortası poliçenizi zaman kaybetmeden internet üzerinden hemen yaptırabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com uzmanları DASK fiyatı için size en uygun primi sunarak, deprem risklerini güvence altına almanıza yardımcı olur.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK (Zorunlu Deprem Sigortası) Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Konut sigortası ile sıklıkla karıştırılan zorunlu deprem sigortası, deprem sonucunda oluşan zararları güvence altına alarak evinizi ve ailenizi korur.',
          subList: null
        },
        {
          paragraph:
            'Deprem sigortası, kayıplarınızın karşılanmasına yardımcı olabilir. Depremler ani gelir ve ne zaman olacağını bilemeyiz. Meydana geldiği an saniyeler içinde büyük yıkımlara neden olur.',
          subList: null
        },
        {
          paragraph:
            'Yıkımlara karşı binanıza verilecek zararları karşılamak için <strong><em>deprem sigortası</em></strong> satın alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Hasarı İçin Nereye Başvurulur?',
      content: [
        {
          paragraph:
            'Deprem sonrasında poliçe ve hasara neden olan depremin bilgileri ile ALO DASK 125 aranmalıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK İçin Gerekli Belgeler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'DASK poliçesi yaptırırken sigortacınıza doğru ve eksiksiz bilgi vermelisiniz. Poliçe kapsamında yer alan bilgilerin yanlış olması sonucunda hasar anında sorun yaşayabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em>Sigortalının kimlik ve iletişim bilgileri;</em></strong>',
          subList: [
            'Adı - Soyadı',
            'Adresi',
            'Cep Telefonu',
            'T.C. Kimlik Numarası',
            'Vergi Kimlik Numarası (Tüzel Kişiler için)'
          ]
        },
        {
          paragraph:
            '<strong><em>Sigortalanacak Binanın Bilgileri;</em></strong>',
          subList: [
            'Açık Adres',
            'Hasar Durumu',
            'İnşa Yılı',
            'Tapu Bilgileri',
            'Toplam Kat Sayısı',
            'Yapı Tarzı'
          ]
        },
        {
          paragraph:
            '<strong><em>Sigortalanacak Dairenin Bilgileri;</em></strong>',
          subList: ['Brüt Yüzölçümü (m2)', 'Kullanım Şekli gereklidir.']
        }
      ]
    },
    {
      title: 'DASK Yangını Kapsar Mı?',
      content: [
        {
          paragraph:
            'DASK yangının deprem sonucu oluşması şartıyla yangın hasrını karşılar.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK İle Konut Sigortası Arasındaki Fark Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'DASK poliçesi devlet tarafından zorunlu tutulmuştur. Konut poliçesi isteğe bağlıdır.',
            'DASK poliçesi sadece deprem sonucu oluşan bina hasarını öder. Konut poliçesi deprem, yangın, sel su baskını gibi kapsama eklenmiş zarar görebilecek eşyalar içinde ödeme yapar.',
            'DASK zorunlu bir poliçe olduğu için iptal edilemez, konut poliçesi isteğe bağlı olduğu için iptal edilebilir.',
            'DASK maddi kayıpları karşılar, konut poliçesi istenen teminatlar ile daha fazla güvence sağlamaktadır.',
            'DASK poliçesinde teminatta üst limit vardır. (2021 yılı için 268.000 TL) Konut poliçesinde limitleri sigortalı metrekare hesabına göre kendisi belirler.',
            'DASK poliçesinde en yüksek indirim oranı %20’dir. Konut poliçesinde sigortalıya göre ek indirimler uygulanabilir'
          ]
        }
      ]
    },
    {
      title:
        'Zorunlu Deprem Sigortası Yaptırmadan Konut Poliçesi Yaptırmak Mümkün Mü?',
      content: [
        {
          paragraph:
            'Evet, mümkündür. Ancak konut poliçesindeki bina limiti DASK poliçesindeki üst limittin (2021 yılı 268.000 TL) üstündeki tutardan başlar.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Nereye Ödenir?',
      content: [
        {
          paragraph: 'DASK poliçenin tanzim edildiği yere nakit olarak ödenir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Ödenmezse Ne Olur?',
      content: [
        {
          paragraph:
            'DASK poliçe tanzim sırasında ödeme aldığından ödenmeme ihtimali yoktur.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Deprem Sigortasında Tazminat Ödenmesi Ne Şekilde Olur?',
      content: [
        {
          paragraph:
            'Tazminat ödemesi sigortalıya teminat bedeli üzerinden %2 muafiyet düşülerek yapılır.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK (Zorunlu Deprem Sigortası) İptali Yapılır Mı?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası, zorunlu bir poliçe olup iptal edilemez. Mükerrerlik ve Riskin ortadan kalkması durumlarında iptal edilebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Ev Satışından Sonra DASK İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'DASK satış sözleşmesinin poliçeyi kesen tarafa iletilmesinden sonra iptal edilebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK (Zorunlu Deprem Sigortası) Hasar İhbarı Nereye Yapılır?',
      content: [
        {
          paragraph:
            'Deprem kaynaklı bir hasar meydana gelme durumunda telefonunuzda 125 ALO DASK’ı aramanız yeterlidir. Hasar ihbarını telefon yoluyla arayarak yapabileceğiniz gibi online işlemler aracılığıyla da yapabilirsiniz. Online hasar ihbarı yapmak isteyen sigortalılar https://www.dask.gov.tr/ adresi ziyaret edebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Poliçe No Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'DASK poliçe no sorgulaması E- Devlet üzerinden yapılabileceği gibi dask.gov.tr adresinden de yapılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK UAVT Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ulusal Adres Veri Tabanı’nın kısaltmış adına UAVT kodu konutunuzun bilgilerini içermektedir.',
          subList: null
        },
        {
          paragraph:
            'UAVT Sorgulamasını yapmak için E-Devlet’i kullanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Deprem Sigortası Ücreti/Primi Neye Göre Belirlenir?',
      content: [
        {
          paragraph: '<strong>Deprem Sigortası Primi;</strong>',
          subList: [
            'Binanın deprem risk bölgesinde olup olmadığı',
            'Binanın yapı tarzı (betonarme, karkas, çelik tam kâgir)',
            'Binanın brüt yüzölçümü hesaplanarak yapılır.'
          ]
        }
      ]
    },
    {
      title: 'DASK (Zorunlu Deprem Sigortası) Teklifi Almak İçin Ne Yapılır?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası yaptırmak için web sitemizde yer alan başvuru formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'İnternetten DASK Sigortası Yaptırmak Güvenli Mi? (Online DASK Yapma)',
      content: [
        {
          paragraph:
            'Online DASK poliçesi yaptırmak için internet ortamı ile sağlanan destekler güvenlidir. Bu noktada özellikle online satın alacaksanız, güvenilir siteye kart bilgilerinizi ilettiğinizden emin olmalısınız.',
          subList: null
        },
        {
          paragraph:
            'Kart bilgilerinizi online girmek istemiyorsanız, uzmanlarımızı arayarak <strong><em><u>0216 371 67 77</u></em></strong> numaralı hattan telefon yoluyla hızlı çözüm alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kredi Kartı ile Online DASK Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Kredi kart bilgilerinizi ilgili teklif ekranına girerek online satın alım yapabilirsiniz. DASK fiyatlarını karşılaştırmak için sizden talep edilen bilgileri forma yazmanız ve teklif al butonuna tıklamanız sonucunda size en uygun deprem sigortası fiyatları iletilir. Bu noktada tercih edeceğiniz sigorta şirketinin fiyatını seçerek, kredi kartınız ile online satın alma yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'DASK’ı (Zorunlu Deprem Sigortası) Ev Sahibi Mi Kiracı Mı Yaptırır?',
      content: [
        {
          paragraph:
            'DASK poliçesinde sigortalı ev sahibi olmaktadır. Poliçeyi her iki tarafta yaptırabilir. Fakat sigorta da sigorta ettiren kısımda yer alan kişi tarafından ödeme yapılır. Yani her iki durumda da deprem sigortası ev sahibi adına düzenlenecektir.',
          subList: null
        },
        {
          paragraph:
            'Kiracı olan kişiler sigorta ettiren olarak zorunlu deprem sigortası yaptırabilir ve DASK primini ev sahibinden talep edebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Ne Kadar Ödeme Yapar?',
      content: [
        {
          paragraph:
            'DASK her takvim yılı için bağımsız bölüm teminat üst limiti belirlemektedir.',
          subList: null
        },
        {
          paragraph:
            '2021 yılı için bu bedel 268.000 TL’dir. Teminat bedeli üzerinde %2 muafiyet vardır. Sadece Bina ortak alanlarındaki hasarlar için sigortalının taşınmazdaki hissesi oranında ödeme yapılır.',
          subList: null
        }
      ]
    },
    {
      title: 'DASK (Poliçe) Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph: 'DASK hesaplaması:',
          subList: [
            'İl/ İlçe/ Bucak-Köy/ Mahalle',
            'Bina Yapı Tarzı',
            'Bina İnşa Yılı',
            'Toplam Kat Sayısı',
            'Daire Yüzölçümü',
            'Yenileme Numarası baz alınarak yapılmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'DASK Zorunlu Deprem Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'DASK (Zorunlu Deprem Sigortası) fiyatı verilmesi için binanın bulunduğu deprem bölgesi, yapı tarzı ve yüzölçümünün bilinmesi gerekmektedir.',
          subList: null
        },
        {
          paragraph:
            'DASK ücretleri, Hazine ve Maliye Bakanlığı tarafından zorunlu deprem sigortası tarifesi ve talimat tebliğiyle belirlenir. En uygun deprem sigortası fiyatlarını hesaplamak için Alokasko.com üzerinden teklif alabilirsiniz.            ',
          subList: null
        }
      ]
    },
    {
      title: 'DASK Fiyatları Değişir Mi?',
      content: [
        {
          paragraph:
            'DASK – Deprem sigortası fiyatları sigorta şirketleri arasında pek fark göstermemektedir. Fakat yenilemelerinizi düzenli yaptırıyorsanız, özel indirimlerden yararlanma hakkınız bulunur.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Deprem Sigortası Kaç Para?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası primleri illere göre değişiklik göstermektedir. Deprem risk bölgesine göre konumlanmış fiyatları değerlendirmek için teklif almanız yeterlidir.              ',
          subList: null
        }
      ]
    },
    {
      title: 'En Uygun DASK Nasıl Bulunur?',
      content: [
        {
          paragraph:
            'En uygun deprem sigortası ücretlerine ulaşmak için <strong><em><u>Alokasko.com</u></em></strong> üzerinden fiyat teklifinde bulunabilirsiniz. Tek yapmanız gereken başvuru formunda sizden talep edilen bilgileri eksiksiz ve doğru bir şekilde doldurmanızdır.',
          subList: null
        }
      ]
    }
  ]
}
